import React from 'react'
import { oneOf, object, string } from 'prop-types'

const SIZES = {
  'small': '50px',
  'medium': '100px',
  'large': '200px'
}

export const Loader = ({ size, style, message }) => (
  <div>
    <div
      className='layout--centered'
      style={{
        background: 'url(/app/images/loader.gif) no-repeat center center',
        width: SIZES[size] || '200px',
        height: SIZES[size] || '200px',
        backgroundSize: 'contain',
        ...style
      }}
    />
    { message ? <p className='paragraph--centered' style={{ marginTop: '10px' }}>{message}</p> : '' }
  </div>
)

Loader.propTypes = {
  size: oneOf([ 'small', 'medium', 'large' ]),
  style: object,
  message: string
}

Loader.defaultProps = {
  size: 'large'
}



// WEBPACK FOOTER //
// ./src/components/ui/states/Loader.js